require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-1984-year-women-left-coding.json") })
        }
      }, "path---blog-1984-year-women-left-coding");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-1984-year-women-left-coding!./.cache/json/blog-1984-year-women-left-coding.json
// module id = 550
// module chunks = 231608221292675